import { rollupTransactions } from './rollup.js'

export function runAnalysisIntercoTransactions (transactions) {
  console.log('runAnalysisIntercoTransactions', transactions)

  const transactionsRollup = rollupTransactions(transactions)
  console.log('transactionsRollup', transactionsRollup)

  return transactionsRollup
}
